<template>
    <div :class="{'container': true, 'pd-bot': firstBtnType}" v-if="!fetching">
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220713/1657680351309.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657597407259.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220712/1657597415306.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220712/1657597422964.png">
        </div>
        <div class="section-main">
            <div class="s-main">
                <van-tabs :swipe-threshold="6" v-model="active">
                    <van-tab v-for="(item, index) in (tabMain.stageList || [])" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210619/1618820066232.png">
                        <div class="target">
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">阶段目标达成</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon-i"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title title1">
                                <div class="target-link"></div>
                                <div class="text">核心内容模块</div>
                            </div>
                            <div class="content content2">
                                <div class="left">
                                    <div v-for="(val,ind) in item.skillsList.left" :key="ind" class="content-list content-list2">
                                        <div class="icon-i"></div>
                                        <div class="text">{{val}}</div>
                                    </div>
                                </div>
                                <div class="right">
                                    <div v-for="(val,ind) in item.skillsList.right" :key="ind" class="content-list content-list2">
                                        <div class="icon-i"></div>
                                        <div class="text">{{val}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.tips.length" class="title title1">
                                <div class="target-link"></div>
                                <div class="text">实战应用</div>
                            </div>
                            <div v-if="item.tips.length" class="content">
                                <div v-for="(val,ind) in item.tips" :key="ind" class="content-list">
                                    <div class="icon-i"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
                <button class="btn-receive" @click="JumpFn('领取完整课程安排')">
                    <img src="https://s20.lgstatic.com/growth/activity/20220712/1657597796791.png">
                </button>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657598000703.png">
            <div class="current-container-wrap">
                <div class="swiper-container current-container" id="sw-section">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in swiperList"
                            :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value"/>
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657598023579.png">
        </div>
        <div class="sw2" id="sw2">
            <div class="swiper-container current-container2" id="sw-section2">
                <div class="swiper-wrapper current-wraps">
                    <div
                        v-for="(value,inde) in swiperList2"
                        :key="inde"
                        class="swiper-slide current-box"
                    >
                        <img class="company" :src="value"/>
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657598037314.png">
        </div>
        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div class="modal-content active">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div>
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template>
            <ClueFooter
                :bgStyle="{background: 'linear-gradient(90deg, #FEB64C 0%, #FE5E0E 100%)'}"
                v-if="firstBtnType"
                @jump="JumpFn('名额有限立即抢占')"
                :id="133"
                :isDcsj="false"
                showPoup
            />
            <button class="footer" @click="JumpFn('名额有限立即抢占')" v-else>
                <img :src="btnImg.footer">
                <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
                <FooterPoup
                    :id="133"
                    :isDcsj="false"
                />
            </button>
        </template>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { Tab, Tabs } from 'vant';
import activity from '../../../common/activity';
Vue.use(Tab);
Vue.use(Tabs);

import List from './list'
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
    },
    data() {
        return {
            activity,
            List,
            moadlData:{},//弹窗
            imgList:[],
            tabMain:{},
            btnImg:{},
            active: 0,
            active_img:0,
            modalVisable:false,
            tabImgList:[],
            swiperList: [
                "https://s21.lgstatic.com/growth/activity/20220712/1657606807198.png",
                "https://s20.lgstatic.com/growth/activity/20220712/1657606816115.png",
                "https://s20.lgstatic.com/growth/activity/20220712/1657606826245.png",
                "https://s21.lgstatic.com/growth/activity/20220713/1657680271590.png",
            ],
            swiperList2: [
                "https://s20.lgstatic.com/growth/activity/20220712/1657607277902.png",
                "https://s21.lgstatic.com/growth/activity/20220712/1657607288670.png",
                "https://s20.lgstatic.com/growth/activity/20220712/1657607299871.png"
            ],
            addressIdsMap: {
                "领取完整课程安排": "u1tya",
                "名额有限立即抢占": "v1tyb"
            }
        }
    },
    created () {
        this.saLogin();
    },
    mounted () {
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: 'u1ssr'});
            this.platTrack('h5pv', {
                page_id: 'u1ssr',
            })
            this.renderSwipers();
        },500)
        let dataList = this.List.data.h5;
        this.tabMain = this.List.data.tabMain

        this.imgList = dataList.imgList
        this.btnImg = dataList.btnImg
        this.tabImgList = dataList.tabImgList
    },
    methods: {
        renderSwipers() {
            let that = this;
            let option = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
            };
            const swiper1 = new Swiper('.current-container', option);
            let option2 = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 10
            };
            const swiper2 = new Swiper('.current-container2', option2);
        },
        JumpFn(str) {
            // let button_name = '领取详细课程大纲'
            // if(name && typeof name ==='string'){
            //     button_name = name
            // }
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': 'u1ssr',
            //     'button_name': button_name
            // });
            str && this.platTrackClickFn(str)
            setTimeout(() => {
                let key = 'f331871ccf91414896e61eacd84d1429';
                handleJumpUrl(key);
            }, 200)
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        showModal(item){
            console.log(item);
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        platTrackClickFn(name) {
            this.platTrack('h5click', {
                page_id: 'u1ssr',
                address_id: this.addressIdsMap[name]
            })
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #F7F7F7;
    padding-bottom: 100px;
    &.pd-bot {
        padding-bottom: 165px;
    }
    .icon {
      width: 158px;
      height: 158px;
      object-fit: contain;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 9;
    }
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .recevice-btn {
            position: absolute;
            left: 50%;
            bottom: 40px;
            width: 490px;
            height: 98px;
            transform: translateX(-50%);
        }
        .current-container-wrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 490px;
            box-sizing: border-box;
            overflow: hidden;
            .current-container {
                width: 100%;
                height: 348px;
                position: absolute;
                bottom: 0;
                left: 0;
                .current-wraps {
                    width: 587px;
                    position: absolute;
                    padding-left: 10px;
                    .current-box {
                        width:100% !important;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
    .section-main {
        position: relative;
        width: 100%;
        padding-top: 30px;
        margin-bottom: 30px;
        .s-title {
            position: absolute;
            top: 30px;
            left: 0;
            width: 719px;
            height: 131px;
        }
        .s-main {
            // position: relative;
            margin: 0 auto;
            width: 688px;
            background-color: #fff;
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 100px;
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #555;
                    font-weight: 500;
                    padding: 25px 0 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #3D3D3F;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                    }
                    .title1 {
                        margin-top: 38px;
                    }
                    .target-link {
                        width: 6px;
                        height: 22px;
                        background-image: linear-gradient(-41deg, #80FDFE 0%, #7EF3FE 15%, #64B1FF 97%);
                        margin-left: 46px;
                        margin-right: 8px;
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon-i {
                            width: 8px;
                            height: 8px;
                            background: #565659;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                            // padding-left: 60px;
                        }
                    }
                    .content2 {
                        display: flex;
                        flex-wrap: wrap;
                    }
                    .left {
                        width: 50%;
                    }
                    .right {
                        width: 50%;
                        .icon-i {
                            margin-left: 26px;
                        }
                    }
                    .content-list2 {
                        display: flex;
                    }
                }
            }
        }
        /deep/ .van-tabs__wrap--scrollable{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: linear-gradient(354deg, #412EC8 0%, #1E1C54 100%);
            height: 106px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 180px;
            height: 106px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #fff;
            width: 64px;
            height: 6px;
        }
        .btn-receive {
            position: absolute;
            bottom: -55px;
            left: 50%;
            transform: translate(-50%);
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 488px;
            height: 98px;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .f-img {
      margin-top: -180px;
    }
    .tab-img {
        position: relative;
        margin: 30px auto 30px;
        width: 690px;
        background-color: #fff;
        border-radius: 0px 20px 20px 20px;
        padding-bottom: 30px;
        /deep/ .van-tabs__wrap--scrollable{
            height: 86px;
        }
        /deep/ .van-tabs__nav {
            background: rgba(26, 29, 60, 1);
            height: 86px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-right-radius: 20px;
        }
        /deep/ .van-tab {
            width: 189px;
            height: 86px;
            color: #fff;
            font-size: 30px;
            font-weight: 500;
            background: url('https://s21.lgstatic.com/growth/activity/20210419/1618826009731.png') no-repeat center;
            background-size: 100% 100%;
        }
        /deep/ .van-tab--active {
            background: #fff;
            color: #34397D;
            border-top-right-radius: 20px;
        }
        /deep/ .van-tabs__line {
            background:transparent;
        }
        /deep/ .van-tabs__nav--line {
            padding-bottom: 0;
        }
        .tb {
            width: 100%;
            .img {
                width: 100%;
                display: block;
            }
        }
        .btn-getmore {
            position: absolute;
            bottom: -50px;
            left: 50%;
            transform: translate(-50%);
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 488px;
            height: 98px;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .tab-fill {
        width: 100%;
        height: 250px;
        background-color: rgba(33, 52, 110, 1);
        margin-top: -150px;
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        // box-shadow: 0 30px 20px 30px #ccc;
        img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
    }
}
.layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
.modal {
    position: fixed;
    bottom: 139px;
    z-index: 10;
    display: flex;
    justify-content: center;
    .modal-content {
        width: 750px;
        height: 0;
        opacity: 0;
        transition: height .3s linear;
        overflow-y: scroll;
        &.active {
            opacity: 1;
            height: 962px;
            overflow: hidden;
        }
        background: #fff;
        border-radius: 18px 18px 0 0;
        position: relative;
        margin-right: 45px;
        box-sizing: border-box;
    }
    .close {
        width: 42px;
        height: 42px;
        background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
        background-size: 42px 42px;
        position: absolute;
        right: 30px;
        top: 30px;
        border-radius: 50%;
        z-index: 1;
    }
    .title {
        margin-top: 82px;
        width: 658px;
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 41px;
        padding-left: 45px;
        font-weight: bold;
        &-dot {
            width: 5px;
            height: 5px;
            border-radius: 5px;
            background: #FA4000;
        }
        .sub-title{
            color: #C69C6D;
            font-size: 26px;
            margin-top: 8px;
        }
    }
    .content {
        height: 755px;
        overflow-y: scroll;
    }
    .content-title {
        margin-bottom: 20px;
        font-weight: bold;
        color: #191F34;
        position: relative;
        padding-left: 47px;
        font-size: 26px;
        line-height: 28px;
        padding-right: 30px;
        &:before {
            content: '';
            width: 8px;
            height: 8px;
            background: #C69C6D;
            border-radius: 8px;
            position: absolute;
            left: 25px;
            top: 11px;
        }
    }
    .content-desi {
        margin-bottom: 30px;
        color: #5E6476;
        font-size: 26px;
        padding-left: 48px;
        padding-right: 30px;
    }
}
.sw2 {
    position: relative;
    width: 100%;
    height: 674px;
    padding: 0 28px;
    box-sizing: border-box;
    img {
        width: 357px;
    }
    .current-container2 {
        width: calc(100% - 30px);
        height: 674px;
        position: absolute;
        bottom: 0;
        left: 30px;
        .current-wraps {
            width: 357px;
            position: absolute;
            padding-left: 10px;
            .current-box {
                width:357px !important;
                // margin-left: 20px;
                img {
                    width: 100%;
                }
            }
        }
    }
}
</style>
